export default {
  LOADING_TABLE: 'ACCOUNTS_VIEW_PNL_LOADING_TABLE',
  LOADED_TABLE: 'ACCOUNTS_VIEW_PNL_LOADED_TABLE',
  LOADING_CHART: 'ACCOUNTS_VIEW_PNL_LOADING_CHART',
  LOADED_CHART: 'ACCOUNTS_VIEW_PNL_LOADED_CHART',
};
